export default import.meta.ROLLDOWN_FILE_URL_YxUXN4jGN9rNFtUJJlYGtw